import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import './App.css';
import AdminHome from './views/Admin/Home/Home';
import Dashboard from './views/Employee/Dashboard/Dashboard';
import axios from 'axios';
import { useState, useEffect } from 'react';
import { useHistory } from "react-router";
import ToastComp from './components/Toast/Toast';
import { withRouter } from "react-router";
import Loader from './components/Loader/Loader';
import Landing from './views/Common/Landing/sections/Landing';
import Signup from './views/Common/Signup/Signup';
import SAHome from './views/SuperAdmin/Home/Home';
import PlatformHome from './views/PlatformAdmin/Home/Home';
import { Toaster } from 'react-hot-toast';

function App() {
  const [error, setError] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (error) {
      //history.push("/login");
      setTimeout(() => {
        window.location.reload();
      }, 1000)
    }
  }, [error, history])


  axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    console.error("Error in response interceptor:", error);
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      setError(true)
      setTimeout(() => {
        window.location.href = '/';
      }, 1000)
    } else {
      return Promise.reject(error);
    }
  });


  return (
    <div className="App">
      <Loader loading={error}></Loader>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          success: {
            style: {
              background: 'green',
              color: 'white',
            },
            iconTheme: {
              primary: 'white',
              secondary: 'green',
            },
          },
          error: {
            style: {
              background: 'red',
              color: 'white',
            },
          },
        }}
      />
      {error ? <ToastComp case='session-error' handler={() => setError(false)} /> : ""}
      <Router basename="">
        <Switch>
          <Route path="/landing" component={Landing} exact></Route>
          <Route path="/signup" component={Signup} exact></Route>
          <Route path="/admin" component={AdminHome} ></Route>
          <Route path='/user' component={Dashboard}></Route>
          <Route path='/org-admin' component={SAHome}></Route>
          <Route path='/platform-admin' component={PlatformHome}></Route>

          {/* Redirect to landing page if no route matches */}
          <Route path='/' component={Landing} exact></Route>

          <Route path="/*">
            <Redirect to='/landing' />
          </Route>
        </Switch>
      </Router>
    </div>



  );
}
export default withRouter(App);
